/**
 * 好物详情页数据
 */
import { getSku, getDetail } from '$services/goods'

export default {
  namespaced: true,
  state: {
    goodsSkus: [
      // {
      //   skuId: 'ueieMz',
      //   skuName: 'iPhone X 6g 全网通 5.0寸 黑色 64G',
      //   goodsTitle: 'iPhone X',
      //   storeSkuId: 'S20180719715762',
      //   specs: ['uQNrEn', 'euqqYr', 'rMZ77z', '36fiy2', '3YvuEj'],
      //   specValues: null,
      //   marketPrice: 888800,
      //   investAmount: 100000,
      //   investAnnualRate: 4.5,
      //   investTerm: 365,
      //   expectedRevenue: 450000
      // },
      // {
      //   skuId: 'JnuQje',
      //   skuName: 'iPhone X 6g 全网通 5.0寸 黑色 64G',
      //   goodsTitle: 'iPhone X',
      //   storeSkuId: 'S20180719715762',
      //   specs: ['uQNrEn', 'euqqYr', 'rMZ77z', '36fiy2', '3YvuEj'],
      //   specValues: null,
      //   marketPrice: 888800,
      //   investAmount: 5000000,
      //   investAnnualRate: 3.5,
      //   investTerm: 180,
      //   expectedRevenue: 8630136
      // },
      // {
      //   skuId: '7Nri6b',
      //   skuName: 'iPhone X 6g 全网通 5.0寸 黑色 256G',
      //   goodsTitle: 'iPhone X',
      //   storeSkuId: 'S20180719467777',
      //   specs: ['uQNrEn', 'euqqYr', 'niAjiy', '36fiy2', '3YvuEj'],
      //   specValues: null,
      //   marketPrice: 888800,
      //   investAmount: 10000000,
      //   investAnnualRate: 4.5,
      //   investTerm: 365,
      //   expectedRevenue: 45000000
      // }
    ],
    specList: [
      // [
      //   {
      //     key: 'uU7VVf',
      //     name: '颜色',
      //     value: '黑色',
      //     symbol: 'uQNrEn'
      //   }
      // ],
      // [
      //   {
      //     key: 'bEnquq',
      //     name: '内存',
      //     value: '6g',
      //     symbol: 'euqqYr'
      //   }
      // ],
      // [
      //   {
      //     key: 'QjYbIb',
      //     name: '版本',
      //     value: '256G',
      //     symbol: 'niAjiy'
      //   },
      //   {
      //     key: 'QjYbIb',
      //     name: '版本',
      //     value: '64G',
      //     symbol: 'rMZ77z'
      //   }
      // ],
      // [
      //   {
      //     key: 'U7fY7f',
      //     name: '尺码',
      //     value: '5.0寸',
      //     symbol: '36fiy2'
      //   }
      // ],
      // [
      //   {
      //     key: 'ymQ7na',
      //     name: '运营商',
      //     value: '全网通',
      //     symbol: '3YvuEj'
      //   }
      // ]
    ],
    faqs: [],
    goodsDesc: '',
    goodsName: '',
    goodsNo: '',
    goodsPics: [],
    goodsSku: {
      skuPromotion: {},
    },
    numberOfSold: [],
    getDetailDone: false,
    getAllSkusDone: false,
  },
  mutations: {
    updateGoodDetail(state, payload) {
      state.faqs = payload.faqs
      state.goodsDesc = payload.goodsDesc
      state.goodsName = payload.goodsName
      state.goodsNo = payload.goodsNo
      state.goodsPics = payload.goodsPics
      state.goodsSku = payload.goodsSku
      state.numberOfSold = payload.numberOfSold
      state.goodsSku.investAmount /= 100
      state.goodsSku.marketPrice /= 100
      state.goodsSku.expectedRevenue /= 100
      state.getDetailDone = true
      state.goodsSku.skuPromotion.promotionInvestAmount /= 100
      state.goodsSku.skuPromotion.promotionExpectedRevenue /= 100
    },
    updateAllSkus(state, payload) {
      state.goodsSkus = payload.goodsSkus
      state.goodsSkus.forEach((item) => {
        item.investAmount /= 100
        item.marketPrice /= 100
        item.expectedRevenue /= 100
        item.skuPromotion.promotionExpectedRevenue /= 100
        item.skuPromotion.promotionInvestAmount /= 100
      })
      state.specList = payload.specList
      state.getAllSkusDone = true
    },
    updateGoodSku(state, payload) {
      state.goodsSku = payload
    }
  },
  actions: {
    fetchGoodDetail({ commit }, goodsNo) {
      return getDetail({ goodsNo }).then((data) => {
        commit('updateGoodDetail', data)
      })
    },
    fetchAllSkus({ commit }, goodsNo) {
      return getSku({ goodsNo }).then((data) => {
        commit('updateAllSkus', data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/detail.js